module.exports = __webpack_public_path__ + "./fonts/LatoRegular.ttf";